module.exports = __webpack_public_path__ + "img/2-2.4270c045.jpg";